import type { ApiProblem, TranscriptApiResponse } from '../../src/shared/transcriptApi';

export class TranscriptApiError extends Error {
  constructor(readonly problem: ApiProblem) {
    super(problem.detail);
  }
}

export async function loadTranscript(
  videoId: string,
  options: { trackId?: string; signal?: AbortSignal } = {},
): Promise<TranscriptApiResponse> {
  const query = new URLSearchParams();
  if (options.trackId) query.set('trackId', options.trackId);
  const suffix = query.size > 0 ? `?${query}` : '';
  const response = await fetch(`/api/videos/${encodeURIComponent(videoId)}/transcript${suffix}`, {
    signal: options.signal,
    headers: { Accept: 'application/json' },
  });
  const body = await response.json() as TranscriptApiResponse | ApiProblem;
  if (!response.ok) throw new TranscriptApiError(body as ApiProblem);
  return body as TranscriptApiResponse;
}
